export default class ToolTips {

    static tooltips (selector) {
        $('.tooltip-container', selector).each( function () {
            let $ele = $(this),
                target = typeof $(this).attr('data-target') != 'undefined' ? $(this).attr('data-target') : 'i';
            if(ToolTipMessages[$ele.attr('data-message')] !== undefined) {
                $(target, this).tooltip({
                    placement: $ele.attr('data-placement'),
                    title: ToolTipMessages[$ele.attr('data-message')],
                    html: true
                })
            } else {
            }
        });
    }

    static manualToolTips (element, message, placeholder = 'top', template) {
        $(element).tooltip('dispose');

        let $template;

        switch (template) {
            default:
                $template = '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="visit-calendar tooltip-inner"></div></div>';
                break;
        }

        $(element).tooltip({
            title: message,
            placeholder: 'top',
            html: true,
            template: $template
        })
    }
}

class ToolTipMessages {
    static contactLens() {
        return 'Contact lens';
    }
    static NoneContactLens() {
        return 'Non-Contact lens';
    }
    static testTime() {
        return 'Test time';
    }
    static oct() {
        return 'Optical coherence tomography';
    }
}
